{
  "filters": {
    "creationDate": {
      "label": "Upload date",
      "formatter": {
        "input": "YYYY-MM-DD",
        "tag": "YYYY-MM-DD"
      },
      "periodSeparator": "to",
      "placeholder": "Select a period"
    },
    "searchByNameOrVersion": "Search by name or version",
    "range": "Device types",
    "status": "Status"
  },
  "newFirmware": "Add new firmware",
  "noFirmware": "No firmware available",
  "column": {
    "versionName": "Version Name",
    "type": "Type",
    "declination": "Model",
    "version": "Version",
    "buildDate": "Build date",
    "creationDate": "Upload date",
    "dateFormat": "YYYY-MM-DD [at] hh:mm A",
    "status": "Status"
  },
  "actions": {
    "activate": {
      "label": "Activate the firmware",
      "description": "The firmware {name} will be activated."
    },
    "deactivate": {
      "label": "Deactivate the firmware",
      "description": "The firmware {name} will be deactivated."
    },
    "delete": {
      "label": "Delete the firmware",
      "description": "The firmware {name} will be deleted.",
      "descriptionEmbedded": "The firmware {name} is currently used by a campaign or unitary operation. Its deletion will impact the operations."
    }
  },
  "status": {
    "ACTIVATED": "Active",
    "DEACTIVATED": "Inactive"
  },
  "section": {
    "informations": {
      "title": "Firmware information"
    },
    "compatibility": {
      "title": "Firmware compatibility"
    },
    "complements": {
      "title": "Complements"
    }
  },
  "validation": {
    "name": "Firmware name is required",
    "version": "Firmware version is required"
  },
  "form": {
    "name": "Version Name",
    "description": "Description",
    "version": "Version",
    "range": "Range",
    "declination": "Model",
    "hardwareVersions": "Hardware versions",
    "firmwareVersions": "Firmware versions",
    "status": "Status",
    "minimalCompatibleFirmwareVersion": "Minimal compatible firmware version"
  },
  "upload": {
    "title": "Select a file",
    "browse": "Browse",
    "restrictionInformation": "The firmware must be a ZIP file and no larger than 750 MB.",
    "validation": {
      "fileMandatory": "The file must be in ZIP format.",
      "fileEmpty": "The ZIP file must not be empty.",
      "fileSize": "The ZIP file must be less than 750 MB."
    }
  },
  "firmwareInfo": {
    "compatibility": {
      "title": "Compatibility",
      "description": "The selected firmware has the following dependencies:"
    },
    "equipmentTypeAttached": "Equipment type attached to the firmware",
    "compatibleHardwareVersions": "Compatible hardware versions",
    "compatibleFirmwareVersions": "Compatible firmware versions"
  },
  "selected": "Selected firmware:"
}
